import React, {useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import { niceUnitDisplayer } from '../app/helpers.js'

import { selectResolutionMetersPerUnit } from '../app/inspection.js'
import { toggleCrackmeter } from '../app/interface.js'

import './Crackmeter.css'




function Crackmeter(props) {
  const dispatch = useDispatch()
  const crackmeter_active = useSelector((state) => { return state.interface.crackmeter_active === true });
  const currentResolutionInMap = props.currentResolutionInMap; // in units/pixels
  const unitResolution = useSelector(selectResolutionMetersPerUnit); // in meters/units
  const [crackWidth,setCrackWidth] = useState(1.0); // in mm
  const [crackWidthMin,setCrackWidthMin] = useState(0.1); // in mm. Minimum value of crack width when using the mouse wheel
  const [crackWidthStep,setCrackWidthStep] = useState(0.1); // in mm. Step value of crack width when using the mouse wheel
  const svg_width = 200; // size of the side of the SVG square in screen pixels
  
  // To show/hide the crackmeter
  const toogle_crackmeter = function(){
    if (crackmeter_active) dispatch(toggleCrackmeter({"active": false}));
    else dispatch(toggleCrackmeter({"active": true}));   
  }

  // Transmit an event to make it possible to zoom and move in the map when the mouse is on the crackmeter
  const transmit_wheel_event_to_open_layer = function(e){
    // Get OpenLayer HTML element:
    let element = document.querySelector(".ol-viewport");
    if (element == null) return;

    // Scroll
    if (e.type == "wheel"){
      let new_event = new WheelEvent("wheel", {
        clientX: e.clientX,
        clientY: e.clientY,
        deltaX: e.deltaX,
        deltaY: e.deltaY,
        deltaZ: e.deltaZ,
        deltaMode: e.deltaMode
      });
      element.dispatchEvent(new_event);
    }
  }

  // Scroll on the crack-width input, when not focused
  const handle_wheel_input = function(e){
    let elt = document.querySelector(".crackmeter input");
    let value = parseFloat(elt.value);
    if (e.deltaY < crackWidthMin){
      let new_value = Math.max(crackWidthMin, (Math.round(value/crackWidthStep)+1) * crackWidthStep).toFixed(1);
      setCrackWidth(new_value);
    }
    else if (e.deltaY > crackWidthMin){
      let new_value = Math.max(crackWidthMin, (Math.round(value/crackWidthStep)-1) * crackWidthStep).toFixed(1);
      setCrackWidth(new_value);
    }
    e.stopPropagation();
    e.preventDefault();
  }

  // Event listener on the OpenLayer map to change the crackmeter width
  const global_wheel_event_listener = function(e){
    // We want to take into account the wheel to change the width iff:
    // - the CTRL key is pressed
    // - the crackmeter is active
    if (e.ctrlKey == true && document.querySelector(".crackmeter").style.display != "none"){
      handle_wheel_input(e);
    }
  }
  useEffect(() => {
    let map = document.querySelector(".map-container");
    map.addEventListener("wheel", global_wheel_event_listener, {capture: true});
  },[]);

  // Loading pending
  if (currentResolutionInMap == null){
    return <></>
  }

  return <div>
    <div className={crackmeter_active ? "crackmeter_openclose active" : "crackmeter_openclose"} onClick={toogle_crackmeter}>
      📏 Crackmeter
    </div>
    <div 
      className="crackmeter" 
      onWheel={transmit_wheel_event_to_open_layer}
      style={{"display": (crackmeter_active && unitResolution != null) ? "flex" : "none", "width": svg_width}}>
      <div className="crackmeter_header">
        <div className="crackmeter_title">Crackmeter</div>
        <div className="crackmeter_close" onClick={toogle_crackmeter}>❌</div>
        <div className="crackmeter_crackwidth">
          width: <input type="number" style={{width: "80px"}} value={crackWidth} onChange={(e) => {setCrackWidth(e.target.value);}} onWheel={handle_wheel_input} min={crackWidthMin} step={crackWidthStep}></input>mm
        </div>        
      </div>
      <svg 
        viewBox={(-svg_width/2.0) + " " + (-svg_width/2.0) + " " + svg_width + " " + svg_width}
        style={{"width": svg_width + "px", "height": svg_width + "px"}}
        xmlns="http://www.w3.org/2000/svg"
        className="crackmeter_svg"
      >
        <mask id="crackmeter_mask" maskContentUnits="objectBoundingBox">
          <rect x="0" y="0" width="1" height="1" fill="white" />
          <circle cx="0.5" cy="0.5" r="0.2" fill="black"/>
        </mask>
        <g mask="url(#crackmeter_mask)">
          <rect x={-svg_width/2.0} y={-svg_width/2.0} width={svg_width} height={svg_width} fill="rgba(255, 255, 255, 0.5)"/>
          <circle cx="0" cy="0" r={svg_width*0.2} fillOpacity="0.0" stroke="black" strokeWidth={1.0}/>
          {[0, 90, 45, -45].map((angle) => {
            return (<g key={"angle_" + angle} transform={"rotate(" + angle + ")"}>
              <line x1={-svg_width*0.4} x2={svg_width*0.4} y1="0" y2="0" stroke="black" strokeWidth={crackWidth/1000.0/(unitResolution*currentResolutionInMap)}/>
            </g>)
          })}
        </g>
      </svg>
    </div>
  </div>
}

export default Crackmeter;